/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Link_ErrorInputs */

const vi_kiotviet_link_error = /** @type {(inputs: Kiotviet_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nối sản phẩm thất bại`)
};

/**

* @param {Kiotviet_Link_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_error = /** @type {((inputs?: Kiotviet_Link_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_error(inputs)
});